module.exports = __webpack_public_path__ + "img/1.e35b5d1a.png";